<template>
	<div
		id="app"
		:class="[
			{'landing-page' : $route.path === '/landing'},
			{'gop' : $route.path.startsWith('/gop/')},
			{'blue-bg' : $route.meta.backgroundColor === 'blue'},
			{'white-bg' : $route.meta.backgroundColor === 'white'}
		]"
	>
		<UnauthorizedUserPopup />

		<Header v-if="!isLoginPage && $router.name !== 'reset-password' && $route.path !== '/landing'"/>

    <LandingHeader v-if="$route.path === '/landing'" />

		<ProgressBar v-if="$store.getters.getLoading && !isLoginPage"/>

		<Loading/>

		<ConfirmationPopup />
		<GenericPopup />

		<InitialAnimation v-if="isLoginPage && !localStorage.getItem('attemptedLoginWith')"/>

		<div :class="[{'gop-content-container' : $route.path.includes('/gop/')}, 'content-container', {'redesign-gop-content-container' : $route.path.includes('/gop/')}]">
			<SideMenu v-if="showSidebarOrFooter" />

			<Transition v-if="showSidebarOrFooter">
				<div class="content-cover" v-if="sideMenuOpened" @click="closeSideMenu"></div>
			</Transition>

			<div
				v-if="!isLoading"
				:class="['main-content', { 'main-content-login': isLoginPage || $router.name === 'reset-password'}]"
				ref="mainContent"
				id="mainContent"
			>
				<router-view class="page-enter-smooth" :key="$route.name" />
				<Notification />
				<GopNotification />
				<GlobalSearchInput />
				<BackToTop />
				<Survey />
			</div>
		</div>

		<CrudSideMenu :crudSideMenuData="crudSideMenuData" :is-active="crudSideMenuStatus" v-if="canShowCrudSideMenu" />

		<Transition>
			<div class="crud-sidemenu-cover" v-if="crudSideMenuStatus"></div>
		</Transition>

	</div>
</template>

<script>
import {
	EventBusNavbar,
	EventBusSidebar,
	EventSideMenu,
	EventCurdSideMenu,
	EventBusCase, EventUnauthorizedUserPopup
} from "@/common/configurations/event-bus.js";
import {PAGE_NAME, NOTIFICATION_TYPE, API_HEADER} from "@/common/utils/constants.js";
import CrudSideMenu from "@/drc/components/crud-components/CrudSideMenu";

import ProgressBar from "@/common/components/ProgressBar.vue";
import BackToTop from "@/drc/components/BackToTop.vue";
import UnauthorizedUserPopup from "@/common/components/UnauthorizedUserPopup.vue";
import Header from "@/common/components/Header.vue";
import SideMenu from "@/common/components/sideMenu/SideMenu.vue";
import Notification from '@/drc/components/notifications/Notification';
import * as DRC_SERVICE from '@/drc/services/drc-request-service';
import * as COMMON_SERVICE from '@/common/services/common-request-service';
import GlobalSearchInput from "@/drc/components/globalSearch/GlobalSearchInputModal";
import { fetchUserSavedProjectsIds } from "@/drc/services/user.saved.projects.service"
import ConfirmationPopup from "@/drc/components/ConfirmationPopup.vue";
import LandingHeader from "@/common/components/LandingHeader.vue";
import * as DrcWebsocketService from "@/common/services/websockets/drc.websocket"
import * as ApplicationVersionService from "@/common/services/application.version.service"
import {PERMISSIONS} from "@/common/utils/constants";
import Loading from "@/common/components/Loading.vue";
import InitialAnimation from "@/common/pages/login/InitialAnimation.vue";
import Survey from "@/drc/pages/survey/Survey";
import GenericPopup from '@/common/components/GenericPopup'
import {logout} from "@/common/services/login-service";
import GopNotification from "@/gop-redesign/components/GopNotification.vue";

export default {
	name: "App",
	components: {
		Loading,
    LandingHeader,
		GlobalSearchInput,
		Notification,
		ProgressBar,
		BackToTop,
		UnauthorizedUserPopup,
		Header,
		SideMenu,
		CrudSideMenu,
		ConfirmationPopup,
		InitialAnimation,
		Survey,
		GenericPopup,
		GopNotification
	},
	data() {
		return {
			showNavbar: true,
			showMobileNavbarLayer: false,
			showSidebarOrFooter: !this.isLoginPage,
			pageNames: PAGE_NAME,
			sideMenuOpened: false,
			crudSideMenuStatus: false,
			crudSideMenuData: '',
			isLoading: true,
			localStorage: localStorage
		};
	},
	computed: {
		isLoginPage() {
			return this.$route.name === 'login'
				|| this.$route.name === 'sign-in'
				|| this.$route.name === 'register'
				|| this.$route.name === 'forgot-password'
				|| this.$route.name === 'confirmation'
				|| this.$route.name === 'login-options'
				|| this.$route.name === 'register-success'
				|| this.$route.name === 'reset-password'
		},
		canShowCrudSideMenu() {
			let arr = [
				`${PAGE_NAME.manage}_${PAGE_NAME.content}_${PAGE_NAME.update}`,
				'manage-labels',
				'controlPanelManageLabels'
			];

			return arr.includes(this.$route.name);
		}
	},
	created() {
		this.setJwtToAxiosConfigIfExists();
		let jwt = localStorage.getItem('jwt');
		if (!this.isLoginPage && jwt) {
			let formated = jwt.replaceAll('"', '').replaceAll('Bearer ', '');

			COMMON_SERVICE.validateJWT(formated)
				.then((response) => {
					response.data.jwt = formated;
					this.$store.dispatch('setUserData', response);
					this.checkForChatNow();
					this.isLoading = false;

					let routePermissions = this.$route.meta.permissions;
					let userPermissions = this.$store.getters.getUser.permissions;
					if (!this.hasPermission(PERMISSIONS.defaultAccess)) {
						logout();
						return;
					} else if (routePermissions && !userPermissions.some(permission => routePermissions.includes(permission))) {
						this.$router.push('/landing');
					}

					this.setListeners();
					this.fetchFiltersData();
					fetchUserSavedProjectsIds();
					this.syncManagementFilters();
				})
				.catch((error) => {
          console.error(error);
          EventUnauthorizedUserPopup.$emit("start-unauthorized-user-popup");
					this.isLoading = false;
        });

		} else {
			this.showSidebarOrFooter = false;
			this.isLoading = false;
		}
		//this.fillStoreWithCommonData();
		this.$store.dispatch('setPublicData');
	},
	mounted() {
		if(window.location.pathname.startsWith('/projects/')) {
			this.$loader.show({text: '', description: '', buttonText: null, isBlue: true, onCancel: () => {}});
		}

		DrcWebsocketService.initializeWebSocket()
			.then(async () => {
				await ApplicationVersionService.updateApplicationVersion();
			})
			.catch((error) => console.error(error));
		EventBusCase.$on('cleanCache', this.cleanCache)
	},
	unmounted() {
		DrcWebsocketService.disconnectWebSocket();
	},
	beforeDestroy() {
		EventBusCase.$off('cleanCache')
	},
	destroyed() {
		EventBusCase.$off('redirectToContinueDraft');
		EventBusNavbar.$off("show-navbar");
		EventBusNavbar.$off("show-mobile-navbar");
		EventSideMenu.$off('toggle-sidemenu');
		EventCurdSideMenu.$off('toggle-side-menu');
		EventCurdSideMenu.$off('close-side-menu');
		EventSideMenu.$off("close-cover");
	},
	methods: {
		checkForChatNow(){
			const allowedEmails = ['vasil.ayvazov@akkodis.com', 'petar.stoyanov@akkodis.com', 'sabiha.mangova@akkodis.com', 'desislava.aleksandrova@akkodis.com',
				'plamen.velichkov@akkodis.com', 'pavlina.venkova@akkodis.com', 'thibaut.vachet@akkodis.com', 'thibaut.vachet@akkodisgroup.com', 'sebastien.jullien@akkodis.com',
				'martin.nikolov@akkodis.com', 'nicolas@heymadeleine.com', 'jeffrey.sachs@akkodisgroup.com', 'victor.de-longevialle@akkodis.com', 'antoine-amaury.guillerm@akkodis.com',
				'estelle.higgins@akkodis.com', 'debasis.bisoi@akkodis.com', 'segolene.chambrier@akkodis.com', 'sebastien.lauvergne@akkodis.com', 'bertrand.girardeau@akkodis.com',
				'jacques.deperetti@akkodis.com', 'christian.krapichler@akkodis.com', 'olivier.mathelot-orban@akkodis.com', 'joshua.morley@akkodisgroup.com', 'james.bromberger@akkodis.com',
				'ivan.katsarski@akkodis.com', 'filipe.barbosa@akkodis.com', 'gmi@akkodis.dk', 'maria.bergving@akkodisgroup.com', 'temitope.ayorinde@akkodis.com', 'annabelle.ducellier@akkodis.com',
				'sei@akkodis.no', 'wayne.trimble@akkodisgroup.com', 'kimela.tipton@akkodisgroup.com', 'stephane.averty@akkodis.com', 'franck.maurin@akkodis.com', 'sarah.goeller@akkodis.com',
				'sebastien.ramirez@akkodis.com', 'sarah.otley@akkodisgroup.com', 'carol.gobby@akkodis.com', 'matthew.chapman@akkodis.com', 'jo.debecker@akkodis.com', ' sebastien.sauvage@akkodis.com',
				'vladimir.valev@akkodis.com', 'karla.el-harfouch@akkodis.com', 'geraldine.laloux@akkodis.com', 'arnaud.durel@akkodis.com'
			];
			if(allowedEmails.indexOf(this.$store.getters.getUser.email.toLowerCase()) === -1){
				if(document.getElementById('aicore-chatnow-embed-chat-container')){
					document.getElementById('aicore-chatnow-embed-chat-container').remove();
				}
				if(document.getElementById('aicore-chatnow-embed-chat-button-container')){
					document.getElementById('aicore-chatnow-embed-chat-button-container').remove();
				}
			}else{
				if(document.getElementById('aicore-chatnow-embed-chat-container')){
					document.getElementById('aicore-chatnow-embed-chat-container').style.visibility = "visible";
					document.getElementById('aicore-chatnow-embed-chat-container').parentNode.classList.add('showChild')
				}
			}

			const chatbotElement = document.getElementById('aicore-chatnow-chat');
			if (chatbotElement) {
				chatbotElement.style.height = 'calc(95% - 65px)';
			}

		},
		cleanCache() {
			const message = this.$t('notifications.reload');
			this.showNotification(message, NOTIFICATION_TYPE.SUCCESS);
			setTimeout(() => window.location.reload(true), 1000)
		},
		setListeners() {
			EventBusCase.$on('redirectToContinueDraft', this.redirectToContinueDraft);
			EventBusNavbar.$on("show-navbar", this.handleShowNavbar);
			EventBusNavbar.$on("show-mobile-navbar", this.handleShowMobileNavbar);
			EventSideMenu.$on('toggle-sidemenu', this.toggleMainContent);
			EventCurdSideMenu.$on('toggle-side-menu', this.toggleCrudSideMenu);
			EventCurdSideMenu.$on('close-side-menu', this.closeCrudSideMenu);
			EventSideMenu.$on("close-cover", this.closeSideMenuCover);
		},
		closeSideMenuCover() {
			this.sideMenuOpened = false;
		},
		redirectToContinueDraft() {
			let projectId = this.$store.getters.getFieldValue('id');
			if (projectId) {
				this.$router.push(`/submission/continue-draft-project/${projectId}`)
			}
		},
		toggleCrudSideMenu(data) {

			this.crudSideMenuData = data;
			if(data && data.row){
				this.crudSideMenuData.row = {
					...data.row,
					type: String(data.row.type[0]).toUpperCase() + String(data.row.type).slice(1),
					projectCount: data.row.projects.length,
					status: data.row.approvalStatus
				};
			}
			this.crudSideMenuStatus = !this.crudSideMenuStatus;
		},
		closeCrudSideMenu() {
			this.crudSideMenuStatus = false;
		},
		syncManagementFilters() {
			if (this.hasPermission(PERMISSIONS.additionalCmtAccess) || this.hasPermission(PERMISSIONS.additionalAdminAccess)) {
				this.$store.dispatch('syncManagementFiltersStore');
			}
		},
		fetchFiltersData() {
			if (Object.keys(this.$store.getters.getSearchByFilters('filters')).length === 0) {
				DRC_SERVICE.fetchFilters()
					.then((response) => {
						response.forEach(singleResponse => {
							this.$store.dispatch('setSingleFilter', {
								filterType: singleResponse.data[0].filterType,
								value: singleResponse.data
							});
						})
						this.$store.dispatch("setFiltersForSavedProjects", response);
						this.$store.dispatch('setSearchByFilters', { fieldName: 'areFiltersLoaded', value: true })
					})
					.catch((error) => {
						console.error(error)
					})
			}
		},
		closeSideMenu() {
			let sideNavigation = document.getElementsByClassName("sidenav-container")[0];
			if (sideNavigation.classList.contains("active")) {
				EventSideMenu.$emit("toggle-sidemenu");
				EventSideMenu.$emit("toggle-burger-logo");
			}
		},
		setJwtToAxiosConfigIfExists() {
			let jwt = localStorage.getItem(API_HEADER.jwt);
			let isSso = localStorage.getItem('isSso') == 'true';
			if (jwt) {
				const payload = {
					jwt: jwt.replaceAll('"', ''),
					isSso
				}
				this.$store.dispatch('setUserJwtToAxiosConfig', payload);
			}
		},
		handleShowNavbar(doShow) {
			this.showNavbar = doShow;
		},
		handleRemoveMobileNavbar() {
			EventBusNavbar.$emit("animate-remove-mobile-navbar");
			setTimeout(() => {
				this.showMobileNavbarLayer = false;
			}, 500);
		},
		handleShowMobileNavbar() {
			if (this.showMobileNavbarLayer === true) {
				EventBusNavbar.$emit("animate-remove-mobile-navbar");
				setTimeout(() => {
					this.showMobileNavbarLayer = false;
				}, 500);
			} else {
				this.showMobileNavbarLayer = true;
			}
		},
		toggleMainContent() {
			this.sideMenuOpened = !this.sideMenuOpened;
		},
		scrollToTopOfPage() {
			this.$refs.mainContent.scrollTo({
				top: 0,
				left: 0,
				behavior: "smooth",
			});
		}
	},
	watch: {
		$route: function () {
			EventBusSidebar.$emit("hide-sidebar");
			this.$store.dispatch('hideLoading');
			this.handleRemoveMobileNavbar();

			if (this.isLoginPage) {
				this.showSidebarOrFooter = false;
				EventBusNavbar.$emit("show-navbar-routes", false);
			} else {
				this.showSidebarOrFooter = true;
				EventBusNavbar.$emit("show-navbar-routes", true);
			}
			if (!this.isLoading) {
				this.scrollToTopOfPage();
			}

			EventSideMenu.$emit('close-sidemenu');
			EventSideMenu.$emit("close-burger-logo");
			this.sideMenuOpened = false;

		}
	},
};
</script>

<style lang="scss" scoped>
@import "@/common/assets/css/_variables.scss";

#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: $color-white-light;
	overflow-x: hidden;
	background: $color-primary-dark;

	&.gop {
		.main-content{
			background-color: $gop-background;
			color: #000;
		}
	}
	&.blue-bg{
		background-color: #001f33;
	}
	&.white-bg {
		background-color: $gop-new-white;
		color: $gop-new-blue;
	}
}

.page-body {
	min-height: calc(100vh - 100px);
}

.v-enter-active,
.v-leave-active {
	transition: opacity 0.3s ease-in-out;
}

.v-enter-from,
.v-leave-to {
	opacity: 0;
}
</style>
